import { BannerLayout } from '../Shares/BannerLayout';
import { LootBoxesBannerSlide } from './LootBoxesBannerSlide';
export const LootBoxesBanner: React.FC = () => {
  return <BannerLayout>
      <LootBoxesBannerSlide />
      <LootBoxesBannerSlide />
      <LootBoxesBannerSlide />
      <LootBoxesBannerSlide />
    </BannerLayout>;
};